import Toggle from "@/components/form/toggle/Toggle"
import {
  CellParamsType,
  ZoneTabContentRangesType,
  ZoneType,
} from "@/app/settings/metric/zones/components/type"
import { ZONE_CODE_BY_TYPE } from "@/app/settings/metric/zones/components/constants"
import { CustomPlayerMetric, PlayerMetric } from "@/types/metric"

export default function ActiveToggleCell({
  params,
  playerMetrics,
  setPlayerMetrics,
  individualRanges,
  type,
  rowIndex,
  onActivate,
}: {
  params: CellParamsType
  playerMetrics: PlayerMetric[]
  setPlayerMetrics: React.Dispatch<React.SetStateAction<PlayerMetric[]>>
  individualRanges: ZoneTabContentRangesType
  type: ZoneType
  rowIndex: number
  /** 토글을 On 으로 바꾼 행 — 호출부가 그 행의 Max 입력란으로 커서를 옮긴다 (ERR-020) */
  onActivate?: (idfPlayer: number) => void
}) {
  const onChangeCustomMetricActive = (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    const newPlayerMetrics = [...playerMetrics]
    newPlayerMetrics[rowIndex].customMetricActive = checked
    newPlayerMetrics[rowIndex].max = Number(newPlayerMetrics[rowIndex].max).toFixed(1)

    if (checked && !newPlayerMetrics[rowIndex].customMetrics?.length) {
      newPlayerMetrics[rowIndex].customMetrics = Array.from<CustomPlayerMetric>({
        length: individualRanges?.[type].length,
      })
        .fill({
          value: "",
          code: `${ZONE_CODE_BY_TYPE[type]}`,
          type: "ZONE",
        } as CustomPlayerMetric)
        .map((metric, index) => ({
          ...metric,
          code: `${ZONE_CODE_BY_TYPE[type]}${index + 1}`,
        }))
    }

    setPlayerMetrics(newPlayerMetrics)
  }

  const isExpanded = params.row.isExpanded ?? false

  return (
    <div className="zone-tab-table-cell">
      <span className="zone-tab-table-cell-toggle">
        <Toggle
          checked={params.row.active ?? false}
          onChange={(_, checked) => {
            const newPlayerMetrics = [...playerMetrics]
            newPlayerMetrics[rowIndex].active = checked
            setPlayerMetrics(newPlayerMetrics)

            // On 으로 켰을 때만 — 끌 때는 입력란이 비활성이라 옮길 곳이 없다
            if (checked) {
              onActivate?.(params.row.idfPlayer)
            }
          }}
        />
      </span>
      {isExpanded && (
        <span className="zone-tab-table-cell-toggle">
          <Toggle
            checked={params.row.customMetricActive ?? false}
            onChange={onChangeCustomMetricActive}
          />
        </span>
      )}
    </div>
  )
}
